import React from 'react'
import RightsholderMaintenanceBankingTabHeader from '@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceBankingTab/RightsholderMaintenanceBankingTabHeader'
import RightsholderMaintenanceContactTabHeader from '@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceContactTab/RightsholderMaintenanceContactTabHeader'

export const MAINTENANCE_TABS = {
    mailingAndContact: {
        name: 'Identifiers',
        description: <RightsholderMaintenanceContactTabHeader />,
    },
    bankingAndTax: {
        name: 'Banking and Tax',
        description: <RightsholderMaintenanceBankingTabHeader />,
    },
}

export const USER_PROFILE_TABS = {
    user: 'User',
    rightsholders: 'Members',
    songwriters: 'Songwriters',
}
